import React from 'react';
import { Layout, Row, Col, Typography, Space } from 'antd';
import PageHeader from './PageHeader';
import "../../assets/dist/pageHeader/PageHeader.css";

const { Content, Footer } = Layout;
const { Text, Link } = Typography;

const MainLayout = ({ children }) => (
  <Layout style={{ minHeight: '100vh', background: '#f4f7fb' }}>
    <PageHeader />
    <Content style={{ flex: 1 }}>
      <Row justify="center" style={{ margin: 0 }}>
        <Col
          xs={24}
          style={{          
            marginTop: 32,
            minHeight: 'calc(100vh - 72px - 56px)',
           
            background: 'transparent',
          }}
          className='containerwidth'
        >
          {children}
        </Col>
      </Row>
    </Content>
    <Footer
      style={{
        background: '#f4f7fb',
        padding: 0,
        border: 'none',
      }}
    >
      {/* <Row justify="center" style={{ width: '100%', margin: 0 }}>
        <Col
          xs={24}
          className='containerwidth footerLayout'
        >
          <span>LEVRIDGE.AI © 2025</span>
          <Space size="small">
            <Link href="#" style={{ color: '#8691a5' }}>Privacy policy</Link>
            <Text style={{ color: '#8691a5' }}>&amp;</Text>
            <Link href="#" style={{ color: '#8691a5' }}>Terms of service</Link>
          </Space>
        </Col>
      </Row> */}
    </Footer>
  </Layout>
);

export default MainLayout;